import React from 'react'

import Image from 'next/image'

import { Column, Row, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { Container, Divider } from './styles'

type Card = {
  id: string
  name?: string
  jobPosition?: string
  content?: string
  logo?: {
    id: string
    url?: string
    alt?: string
  }
  avatar?: {
    id: string
    url?: string
    alt?: string
  }
}

type Props = {
  data?: Card
}

function TestimonialCard({ data }: Props) {
  const { isMobile, isTablet, isDesktop, isWideDesktop } = useResponsiveLayout()

  if (!data) return null

  const small = isMobile
  const medium = isTablet && !isDesktop
  const large = isDesktop && !isWideDesktop
  const extraLarge = isWideDesktop

  return (
    <Container width={['100%']}>
      <Row alignStart gap={2} height={120} spaceBetween>
        <Column fullHeight gap={2} spaceBetween>
          {data.logo && data.logo.url && data.logo.alt !== undefined && (
            <Image
              alt={data.logo.alt ?? ''}
              height={25}
              src={data.logo.url}
              width={100}
            />
          )}

          <Column gap={1}>
            <Text
              as="h4"
              bold
              important
              nowrap
              screen18={small || medium || large}
              screen24={extraLarge}
            >
              {data?.name}
            </Text>

            <Text
              accent
              medium
              screen14={small || medium || large}
              screen18={extraLarge}
            >
              {data?.jobPosition}
            </Text>
          </Column>
        </Column>

        {data.avatar && data.avatar.url && data.avatar.alt !== undefined && (
          <Image
            alt={data.avatar.alt ?? ''}
            height={120}
            src={data.avatar.url}
            width={120}
          />
        )}
      </Row>

      <Divider my={[3, 3, 3, 3, 3, 6]} />

      <Text
        body
        center
        preWrap
        regular
        screen14={small || medium}
        screen16={extraLarge || large}
      >
        {data?.content}
      </Text>
    </Container>
  )
}

export default TestimonialCard
